var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{style:(_vm.container_style),attrs:{"fluid":"","id":"container"}},[_c('transition',{attrs:{"enter-active-class":"animated fadeIn","name":"router-anim"}},[_c('router-view',{key:_vm.$route.path})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }